import script from "./Cat24Addresses.vue?vue&type=script&setup=true&lang=js"
export * from "./Cat24Addresses.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__